// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   FORGE ECOSYSTEM — Section 04
   ============================================================ */

.eco {
  background: var(--c-cream);
  padding-top: var(--section-y);
  padding-bottom: var(--section-y);
  border-top: 1px solid var(--line);
}

.eco__layout {
  display: grid;
  grid-template-columns: 3rem 1fr;
  gap: clamp(1.5rem, 3vw, 3rem);
  align-items: start;
}

.eco__rail {
  align-self: start;
  padding-top: 0.5rem;
}

.eco__content {
  display: flex;
  flex-direction: column;
  /* gap: var(--sp-3); */
}

/* ── Header: two-tone headline | intro copy ── */
.eco__header {
  display: grid;
  grid-template-columns: 1.1fr 1fr;
  gap: var(--sp-6);
  align-items: end;
  margin-bottom: var(--sp-4);
}
@media (max-width: 767.98px) {
  .eco__header {
    grid-template-columns: 1fr;
  }
}

.eco__eyebrow {
  color: var(--accent);
  display: block;
  margin-bottom: var(--sp-2);
}

.eco__headline {
  margin: 0;
}
.eco__hl-ink {
  font-size: var(--fs-display);
  color: var(--c-forest);
}
.eco__hl-rust {
  font-size: var(--fs-display);
  color: var(--accent);
}

.eco__header-copy {
  font-size: var(--fs-body);
  color: var(--text-muted);
  line-height: var(--lh-body);
  max-width: 42ch;
}

/* ── Sub-section tag pills ── */
.eco__tag {
  display: inline-block;
  align-self: flex-start;
  margin-top: var(--sp-5);
  padding: 4px 14px;
  border-radius: 0.4em 2em 0 0;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: var(--track-eyebrow);
  text-transform: uppercase;
}
.eco__tag--snapshot {
  background: var(--c-sand);
  color: var(--c-ink);
}
.eco__tag--research {
  background: #b9a8d6;
  color: #2e2140;
}
.eco__tag--partnerships {
  background: #e2a37c;
  color: #4a2711;
}

/* ── Tinted subsection panels ── */
.eco__panel {
  border-radius: 0px 16px 16px 16px;
  padding: var(--sp-5);
  border: 1px solid;
}
.eco__panel--snapshot {
  background: rgba(220, 204, 180, 0.28);
  border-color: rgba(220, 204, 180, 0.7);
}
.eco__panel--research {
  background: rgba(185, 168, 214, 0.14);
  border-color: rgba(185, 168, 214, 0.45);
}
.eco__panel--partnerships {
  background: rgba(226, 163, 124, 0.14);
  border-color: rgba(226, 163, 124, 0.45);
}

/* ── Snapshot stats — icon + number ── */
.eco__panel--snapshot {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: var(--sp-4);
}
@media (max-width: 767.98px) {
  .eco__panel--snapshot {
    grid-template-columns: repeat(2, 1fr);
  }
}

.eco__stat {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.eco__stat-icon {
  flex: 0 0 auto;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--c-sage);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.eco__stat-num {
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: clamp(1.5rem, 2.6vw, 2.2rem);
  color: var(--c-ink);
  line-height: 1;
  letter-spacing: -0.01em;
}
.eco__stat-num--serif {
  font-family: var(--font-serif);
  font-weight: 400;
  font-size: clamp(1.2rem, 2vw, 1.6rem);
}
.eco__stat-num--display {
  font-family: var(--font-display);
  font-weight: 400;
  font-size: clamp(1.3rem, 2.2vw, 1.8rem);
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.eco__stat-labels {
  display: flex;
  flex-direction: column;
  gap: 0.05rem;
  margin-top: 2px;
}
.eco__stat-labels span {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.62rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--text-muted);
}

/* ── Partner rows ── */
.eco__partner-row {
  display: grid;
  gap: var(--sp-4);
}
.eco__partner-row--research {
  grid-template-columns: repeat(5, 1fr);
}
.eco__partner-row--partnerships {
  grid-template-columns: repeat(3, 1fr);
}
@media (max-width: 991.98px) {
  .eco__partner-row--research {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 640px) {
  .eco__partner-row--research,
  .eco__partner-row--partnerships {
    grid-template-columns: 1fr;
  }
}

.eco__partner-card {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  padding: var(--sp-4);
  /* background: var(--c-cream); */
  border: 1px solid var(--line);
  border-radius: 10px;
  transition:
    box-shadow 0.25s var(--ease),
    border-color 0.25s var(--ease),
    transform 0.25s var(--ease);
}
.eco__partner-card:hover {
  box-shadow: var(--shadow);
  transform: translateY(-2px);
}
.eco__partner-card--research:hover {
  border-color: #b9a8d6;
}
.eco__partner-card--partnerships:hover {
  border-color: #e2a37c;
}

.eco__partner-logo {
  max-width: 100%;
  max-height: 32px;
  width: auto;
  height: auto;
  object-fit: contain;
  align-self: flex-start;
}

.eco__partner-name {
  font-family: var(--font-body);
  font-weight: 700;
  font-size: var(--fs-xs);
  color: var(--c-ink);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.eco__partner-blurb {
  font-size: 0.78rem;
  color: var(--text-muted);
  line-height: var(--lh-body);
  flex: 1 1;
}

.eco__partner-link-icon {
  align-self: flex-end;
  color: var(--text-muted);
  font-size: 0.75rem;
}

/* Partnerships row: wider cards, horizontal layout with divider */
.eco__partner-row--partnerships .eco__partner-card {
  flex-direction: row;
  align-items: flex-start;
  gap: var(--sp-4);
  padding: var(--sp-5);
}

.eco__partner-row--partnerships .eco__partner-logo {
  flex: 0 0 96px;
  max-width: 96px;
  max-height: 40px;
  margin-top: 4px;
}
.eco__partner-row--partnerships .eco__partner-name {
  text-transform: none;
  font-size: var(--fs-sm);
}
.eco__partner-row--partnerships .eco__partner-blurb {
  font-size: var(--fs-xs);
}
.eco__partner-row--partnerships .eco__partner-link-icon {
  align-self: center;
  margin-left: auto;
}

/* ── Closing CTA bar ── */
.eco__closing {
  margin-top: var(--sp-6);
  display: flex;
  align-items: center;
  gap: var(--sp-4);
  background: var(--c-sage-light);
  border-radius: 14px;
  padding: var(--sp-5) var(--sp-6);
}
@media (max-width: 767.98px) {
  .eco__closing {
    flex-direction: column;
    align-items: flex-start;
  }
}

.eco__closing-icon {
  flex: 0 0 auto;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  color: var(--c-ink);
}

.eco__closing-copy {
  flex: 1 1;
  font-size: var(--fs-sm);
  color: var(--c-ink);
  line-height: var(--lh-body);
}

.eco__closing-cta {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  background: var(--c-forest);
  color: #fff;
  padding: var(--sp-3) var(--sp-5);
  border-radius: 999px;
  font-family: var(--font-body);
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  white-space: nowrap;
}

/* ── Responsive ── */
@media (max-width: 767.98px) {
  .eco__layout {
    grid-template-columns: 1fr;
  }
  .eco__rail {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/ForgeEcosystem.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;AACX;AACA;EACE,4BAA4B;EAC5B,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;AACvC;AACA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,uCAAuC;EACvC,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE;IACE,qCAAqC;EACvC;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,6BAA6B;EAC7B,mBAAmB;EACnB;;;+BAG6B;AAC/B;AACA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,gCAAgC;EAChC,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ============================================================\n   FORGE ECOSYSTEM — Section 04\n   ============================================================ */\n\n.eco {\n  background: var(--c-cream);\n  padding-top: var(--section-y);\n  padding-bottom: var(--section-y);\n  border-top: 1px solid var(--line);\n}\n\n.eco__layout {\n  display: grid;\n  grid-template-columns: 3rem 1fr;\n  gap: clamp(1.5rem, 3vw, 3rem);\n  align-items: start;\n}\n\n.eco__rail {\n  align-self: start;\n  padding-top: 0.5rem;\n}\n\n.eco__content {\n  display: flex;\n  flex-direction: column;\n  /* gap: var(--sp-3); */\n}\n\n/* ── Header: two-tone headline | intro copy ── */\n.eco__header {\n  display: grid;\n  grid-template-columns: 1.1fr 1fr;\n  gap: var(--sp-6);\n  align-items: end;\n  margin-bottom: var(--sp-4);\n}\n@media (max-width: 767.98px) {\n  .eco__header {\n    grid-template-columns: 1fr;\n  }\n}\n\n.eco__eyebrow {\n  color: var(--accent);\n  display: block;\n  margin-bottom: var(--sp-2);\n}\n\n.eco__headline {\n  margin: 0;\n}\n.eco__hl-ink {\n  font-size: var(--fs-display);\n  color: var(--c-forest);\n}\n.eco__hl-rust {\n  font-size: var(--fs-display);\n  color: var(--accent);\n}\n\n.eco__header-copy {\n  font-size: var(--fs-body);\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  max-width: 42ch;\n}\n\n/* ── Sub-section tag pills ── */\n.eco__tag {\n  display: inline-block;\n  align-self: flex-start;\n  margin-top: var(--sp-5);\n  padding: 4px 14px;\n  border-radius: 0.4em 2em 0 0;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: var(--track-eyebrow);\n  text-transform: uppercase;\n}\n.eco__tag--snapshot {\n  background: var(--c-sand);\n  color: var(--c-ink);\n}\n.eco__tag--research {\n  background: #b9a8d6;\n  color: #2e2140;\n}\n.eco__tag--partnerships {\n  background: #e2a37c;\n  color: #4a2711;\n}\n\n/* ── Tinted subsection panels ── */\n.eco__panel {\n  border-radius: 0px 16px 16px 16px;\n  padding: var(--sp-5);\n  border: 1px solid;\n}\n.eco__panel--snapshot {\n  background: rgba(220, 204, 180, 0.28);\n  border-color: rgba(220, 204, 180, 0.7);\n}\n.eco__panel--research {\n  background: rgba(185, 168, 214, 0.14);\n  border-color: rgba(185, 168, 214, 0.45);\n}\n.eco__panel--partnerships {\n  background: rgba(226, 163, 124, 0.14);\n  border-color: rgba(226, 163, 124, 0.45);\n}\n\n/* ── Snapshot stats — icon + number ── */\n.eco__panel--snapshot {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: var(--sp-4);\n}\n@media (max-width: 767.98px) {\n  .eco__panel--snapshot {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.eco__stat {\n  display: flex;\n  align-items: center;\n  gap: var(--sp-3);\n}\n\n.eco__stat-icon {\n  flex: 0 0 auto;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  background: var(--c-sage);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.eco__stat-num {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: clamp(1.5rem, 2.6vw, 2.2rem);\n  color: var(--c-ink);\n  line-height: 1;\n  letter-spacing: -0.01em;\n}\n.eco__stat-num--serif {\n  font-family: var(--font-serif);\n  font-weight: 400;\n  font-size: clamp(1.2rem, 2vw, 1.6rem);\n}\n.eco__stat-num--display {\n  font-family: var(--font-display);\n  font-weight: 400;\n  font-size: clamp(1.3rem, 2.2vw, 1.8rem);\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n.eco__stat-labels {\n  display: flex;\n  flex-direction: column;\n  gap: 0.05rem;\n  margin-top: 2px;\n}\n.eco__stat-labels span {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 0.62rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n}\n\n/* ── Partner rows ── */\n.eco__partner-row {\n  display: grid;\n  gap: var(--sp-4);\n}\n.eco__partner-row--research {\n  grid-template-columns: repeat(5, 1fr);\n}\n.eco__partner-row--partnerships {\n  grid-template-columns: repeat(3, 1fr);\n}\n@media (max-width: 991.98px) {\n  .eco__partner-row--research {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (max-width: 640px) {\n  .eco__partner-row--research,\n  .eco__partner-row--partnerships {\n    grid-template-columns: 1fr;\n  }\n}\n\n.eco__partner-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: var(--sp-2);\n  padding: var(--sp-4);\n  /* background: var(--c-cream); */\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  transition:\n    box-shadow 0.25s var(--ease),\n    border-color 0.25s var(--ease),\n    transform 0.25s var(--ease);\n}\n.eco__partner-card:hover {\n  box-shadow: var(--shadow);\n  transform: translateY(-2px);\n}\n.eco__partner-card--research:hover {\n  border-color: #b9a8d6;\n}\n.eco__partner-card--partnerships:hover {\n  border-color: #e2a37c;\n}\n\n.eco__partner-logo {\n  max-width: 100%;\n  max-height: 32px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  align-self: flex-start;\n}\n\n.eco__partner-name {\n  font-family: var(--font-body);\n  font-weight: 700;\n  font-size: var(--fs-xs);\n  color: var(--c-ink);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.eco__partner-blurb {\n  font-size: 0.78rem;\n  color: var(--text-muted);\n  line-height: var(--lh-body);\n  flex: 1;\n}\n\n.eco__partner-link-icon {\n  align-self: flex-end;\n  color: var(--text-muted);\n  font-size: 0.75rem;\n}\n\n/* Partnerships row: wider cards, horizontal layout with divider */\n.eco__partner-row--partnerships .eco__partner-card {\n  flex-direction: row;\n  align-items: flex-start;\n  gap: var(--sp-4);\n  padding: var(--sp-5);\n}\n\n.eco__partner-row--partnerships .eco__partner-logo {\n  flex: 0 0 96px;\n  max-width: 96px;\n  max-height: 40px;\n  margin-top: 4px;\n}\n.eco__partner-row--partnerships .eco__partner-name {\n  text-transform: none;\n  font-size: var(--fs-sm);\n}\n.eco__partner-row--partnerships .eco__partner-blurb {\n  font-size: var(--fs-xs);\n}\n.eco__partner-row--partnerships .eco__partner-link-icon {\n  align-self: center;\n  margin-left: auto;\n}\n\n/* ── Closing CTA bar ── */\n.eco__closing {\n  margin-top: var(--sp-6);\n  display: flex;\n  align-items: center;\n  gap: var(--sp-4);\n  background: var(--c-sage-light);\n  border-radius: 14px;\n  padding: var(--sp-5) var(--sp-6);\n}\n@media (max-width: 767.98px) {\n  .eco__closing {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.eco__closing-icon {\n  flex: 0 0 auto;\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n  color: var(--c-ink);\n}\n\n.eco__closing-copy {\n  flex: 1;\n  font-size: var(--fs-sm);\n  color: var(--c-ink);\n  line-height: var(--lh-body);\n}\n\n.eco__closing-cta {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sp-2);\n  background: var(--c-forest);\n  color: #fff;\n  padding: var(--sp-3) var(--sp-5);\n  border-radius: 999px;\n  font-family: var(--font-body);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n/* ── Responsive ── */\n@media (max-width: 767.98px) {\n  .eco__layout {\n    grid-template-columns: 1fr;\n  }\n  .eco__rail {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
